import React, { FC, useCallback, useState } from 'react';
import { useClearRefinements } from 'react-instantsearch';
import { RefinementDropdown } from './RefinementDropdown';
import RefinementList from './RefinementList';
import { RefinementSearchInput } from '~/features/productList/components/RefinementSearchInput';
import { FilterSelectionHeader } from '~/features/productList/components/FilterSelectionHeader';
import { RefinementProps } from './RefinementProps';
import useOptimizedRefinementList from '~/shared/hooks/useOptimizedRefinementList';

type RefinementListDropdown = RefinementProps & {
    searchable?: boolean;
    showCount?: boolean;
    searchPlaceholder?: string;
};

export const RefinementListDropdown: FC<RefinementListDropdown> = ({
    attribute,
    searchable,
    showCount = true,
    label,
    searchPlaceholder,
    isVisible = true,
}: RefinementListDropdown) => {
    const [searchValue, setSearchValue] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const { allItems } = useOptimizedRefinementList({ attribute });
    const { refine: clearSelection } = useClearRefinements({ includedAttributes: [attribute] });
    const selectedCount = allItems.filter((item) => item.isRefined).length;

    const onClose = useCallback((open: boolean) => {
        setIsOpen(open);
        if (!open) setSearchValue('');
    }, []);

    const handleSearch = useCallback((value: string) => {
        setSearchValue(value);
    }, []);

    return (
        <RefinementDropdown
            label={label}
            count={selectedCount}
            searchValue={searchValue}
            onChange={onClose}
            topContent={
                <>
                    {searchable && (
                        <RefinementSearchInput
                            value={searchValue}
                            onChange={(event) => handleSearch(event.target.value)}
                            onClear={() => setSearchValue('')}
                            placeholder={searchPlaceholder ?? `Søg på ${label}`}
                        />
                    )}
                    <FilterSelectionHeader
                        label={label ?? ''}
                        selectedCount={selectedCount}
                        onClear={clearSelection}
                    />
                </>
            }
        >
            <RefinementList
                showCount={showCount}
                attribute={attribute}
                isVisible={isVisible}
                searchText={searchValue}
                isOpen={isOpen}
                pinSelection
            />
        </RefinementDropdown>
    );
};
